// Compare-History helpers — localStorage-based (5 entries, dedup by sorted-id key)
const KEY = "carhive_compare_history_v1";
const MAX = 5;

function makeKey(ids) {
  return [...ids].filter(Boolean).sort().join("|");
}

function readRaw() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRaw(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); }
  catch { /* quota — ignore */ }
}

export function getCompareHistory() {
  return readRaw()
    .filter((e) => e && Array.isArray(e.ids) && e.ids.length > 0)
    .slice(0, MAX);
}

export function addCompareEntry({ ids, titles }) {
  if (!Array.isArray(ids) || ids.length === 0) return;
  const key = makeKey(ids);
  const now = new Date().toISOString();
  const list = readRaw().filter((e) => makeKey(e.ids || []) !== key);
  list.unshift({ key, ids: [...ids], titles: Array.isArray(titles) ? titles.slice(0, ids.length) : [], at: now });
  writeRaw(list);
}

export function removeCompareEntry(key) {
  writeRaw(readRaw().filter((e) => e.key !== key));
}

export function clearCompareHistory() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export { MAX as COMPARE_HISTORY_MAX };
